import { initializeApollo } from '~/graphqls/apollo/client'
import { GetServerSidePropsContext } from 'next'
import { GET_CURRENT_USERINFO } from '~/graphqls/gqls'
import { initializeStore } from '~/stores'
import { getSnapshot } from 'mobx-state-tree'
import {
  AccountGroupTypeEnum,
  getCurrentUserInfo,
  getCurrentUserInfo_aiEquity_userMemberCardList,
  getCurrentUserInfo_userinfo,
  CopyrightAuthStatus,
} from '~/graphqls/types'
import { sortBy } from '~/utils'
import { CHAPTER_ID_KEY } from '~/configs'

export const GlobalRequest = async (context: GetServerSidePropsContext) => {
  const client = initializeApollo({ context })
  console.log('GlobalRequest')
  const gateToken = context.req.cookies['gate-token'] || ''
  const showAmount = context.req.cookies['show-amount'] === 'true'
  const homepageLayout = context.req.cookies['homepage-layout'] || null
  const plazaLayout = context.req.cookies['plaza-layout'] || null

  /** 备注：防止邀请码在url切换中丢失，存到cookie和全局store */
  const inviterCode =
    String(context.query.inviteCode) &&
    String(context.query.inviteCode) !== 'undefined'
      ? String(context.query.inviteCode)
      : context.req.cookies['inviterCode'] || null

  /** 技嘉云课程：章节ID */
  const chapterId =
    String(context.query.ID) && String(context.query.ID) !== 'undefined'
      ? String(context.query.ID)
      : context.req.cookies[CHAPTER_ID_KEY] || null

  // TODO 优化实现方式
  const storeOptions: {
    token: string | null
    userinfo: getCurrentUserInfo_userinfo | null
    showAmount: boolean
    modal: any
    ai: any
    inviterCode: string | null
    chapterId: string | null
    aiEquity: getCurrentUserInfo_aiEquity_userMemberCardList[] | null
    layout: {
      'homepage-layout': string | null
      'plaza-layout': string | null
    } | null
  } = {
    token: gateToken,
    userinfo: null,
    inviterCode,
    chapterId,
    showAmount,
    modal: {
      login: false,
      resetPwd: false,
    },
    ai: {
      isRefeshPreviewData: false,
      isRefreshMemberList: false,
      isRefreshTotalInfo: false,
      setIsResetSelectProduct: false,
      isAgain: false,
      comsumedPoints: 0,
    },
    aiEquity: null,
    layout: null,
  }

  if (gateToken) {
    try {
      const { data } = await client.query<getCurrentUserInfo>({
        query: GET_CURRENT_USERINFO,
        fetchPolicy: 'no-cache',
      })

      if (!data.userinfo?.base?.uid) {
        storeOptions.token = null
      } else {
        storeOptions.userinfo = {
          ...data.userinfo,
          isVip: !!data.userinfo.memberDetail?.hold,
          isAiWhiteListUser:
            !!data.pictureGraph?.aiCreateArtworkOptionMenu?.inWhiteList,
          isHighUser:
            !!data.userinfo.memberDetail?.hold ||
            !!data.pictureGraph?.aiCreateArtworkOptionMenu?.inWhiteList,
          areaCode: data.userinfo.authInfo?.areaCode || '86',
        } as getCurrentUserInfo_userinfo
      }

      storeOptions.aiEquity = data.aiEquity?.userMemberCardList?.length
        ? sortBy(
            data.aiEquity
              ?.userMemberCardList as getCurrentUserInfo_aiEquity_userMemberCardList[],
            [
              AccountGroupTypeEnum.ORIGIN_CARD,
              AccountGroupTypeEnum.BRONZE_CARD,
              AccountGroupTypeEnum.SILVER_CARD,
              AccountGroupTypeEnum.GOLD_CARD,
              AccountGroupTypeEnum.PLATINUM_CARD,
            ],
            (it: getCurrentUserInfo_aiEquity_userMemberCardList) => it?.cardType
          )
        : null
    } catch (e) {
      storeOptions.token = null
    }
  }

  storeOptions.layout = {
    'homepage-layout': homepageLayout,
    'plaza-layout': plazaLayout,
  }

  const store = initializeStore(storeOptions)

  // 是否已实名认证
  const isRealName =
    storeOptions.userinfo?.authStatus === CopyrightAuthStatus.AUTH

  /**是否已登录 */
  const isLogin = !!storeOptions.token
  const loginRedirect = (url?: string) => {
    return {
      redirect: {
        destination: url || '/register',
        permanent: false,
      },
    }
  }

  return {
    initialState: getSnapshot(store),
    client,
    isLogin,
    loginRedirect,
    isRealName,
  }
}
